import { render, staticRenderFns } from "./IdentityLogin.vue?vue&type=template&id=c97e1858&"
import script from "./IdentityLogin.vue?vue&type=script&lang=ts&"
export * from "./IdentityLogin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports